import React from "react";
import Tooltip from "../common/tooltip/main";

export default class Attachment extends React.Component {
    handleClick = () => {
        if (!this.props.placing_file) {
            this.props.showProgressBar();
            placeRemoteFile(this.props.attachment);
        }
    };

    render() {
        const { filename, thumbnail_url } = this.props.attachment;
        let tooltipId = `adobe-attachment-tooltip-${thumbnail_url}`;
        return (
            <Tooltip tooltipId={tooltipId} tooltipContent={filename}>
                <div
                    className="adobe-attachment"
                    alt={filename}
                    onClick={this.handleClick}
                >
                    <img
                        ref="image"
                        className="adobe-attachment-thumbnail"
                        src={thumbnail_url}
                    />
                </div>
            </Tooltip>
        );
    }
}
